const DateFormat = require('date-fns/format');
const EndOfWeek = require('date-fns/end_of_week');
const StartOfWeek = require('date-fns/start_of_week');
const EachDay = require('date-fns/each_day');
// const StartOfTomorrow = require('date-fns/start_of_tomorrow');
// const EndOfToday = require('date-fns/end_of_today');
const AddDays = require('date-fns/add_days');
const SubDays = require('date-fns/sub_days');
const GetHours = require('date-fns/get_hours');
const AddMinutes = require('date-fns/add_minutes');
const IsAfter = require('date-fns/is_after');
const IsEqual = require('date-fns/is_equal');
const IsBefore = require('date-fns/is_before');
const DifferenceInMinutes = require('date-fns/difference_in_minutes');
const DifferenceInCalendarDays = require('date-fns/difference_in_calendar_days');
// const LastDayOfMonth = require('date-fns/last_day_of_month');
const StartOfMonth = require('date-fns/start_of_month');
const GetDaysInMonth = require('date-fns/get_days_in_month');
// const GetMonth = require('date-fns/get_month');

export default {
    filters: {
        formatMonth(num) {
            if (!num) return '';

            const str = [
                'January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December',
            ];
            return str[num - 1];
        },
    },

    methods: {
        /**
         * 计算一周内的日期范围
         * @param {String, Date} date 一周内某一天的日期
         */
        handleWeekly(date) {
            const currentWeekly = {
                endOfWeek: DateFormat(EndOfWeek(date, {weekStartsOn: 1}), 'YYYY-MM-DD'),
                startOfWeek: DateFormat(StartOfWeek(date, {weekStartsOn: 1}), 'YYYY-MM-DD'),
            };

            const eachOfDay = EachDay(
                currentWeekly.startOfWeek,
                currentWeekly.endOfWeek
            ).map((el) => {
                const elDate = DateFormat(el, 'YYYY-MM-DD');
                return {
                    date: elDate,
                    day: elDate.slice(5),
                };
            });

            return Object.assign({}, currentWeekly, {eachDay: eachOfDay});
        },

        /**
         * 格式化日期
         * input {string} '2018-11-12 00:12:23'
         * output: {
         *     year: '2018',
         *     month: '11',
         *     day: '12',
         *     hour: '00',
         *     minute: '12',
         *     second: '23',
         *     date: '2018-11-12',
         *     time: '00:12:23',
         * }
         */
        formatDayObj(currentDate) {
            let hourFor24 = GetHours(currentDate);
            if (hourFor24 < 10) hourFor24 = `0${hourFor24}`;

            currentDate = DateFormat(currentDate, 'YYYY-MM-DD hh:mm:ss A');
            const arr = currentDate.split(' ');
            const date = arr[0].split('-');
            const time = arr[1].split(':');

            return {
                year: date[0],
                month: date[1],
                day: date[2],
                hour: hourFor24,
                minute: time[1],
                second: time[2],
                date: arr[0],
                time: `${hourFor24}:${time[1]}:${time[2]}`,
                hourAndMinute: `${time[0]}:${time[1]}`,
                unit: arr[2],
                unitHour: time[0],
            };
        },
        /**
          * 改变当前周
          * @param {boolean} isNextWeek 是否下一周
          * @param {string, date} dateString 本周日期
          */
        handleChangeWeek(isNextWeek = false, dateString) {
            // date: 下个周期的一天
            const date = isNextWeek ? AddDays(dateString, 7) : SubDays(dateString, 7);
            return {
                day: date,
                weekly: this.handleWeekly(date),
            };

            // const promise = this.fetchStaffHours(this.currentId, true, true);
            // promise.then(() => this.initWeek(this.selectDay));
        },

        isAfter(dateLeft, dateRight) {
            return IsAfter(dateLeft, dateRight);
        },

        isEqual(dateLeft, dateRight) {
            return IsEqual(dateLeft, dateRight);
        },

        isBefore(dateLeft, dateRight) {
            return IsBefore(dateLeft, dateRight);
        },

        differenceInMinutes(dateLeft, dateRight) {
            // const between = differenceInMinutes(dateLeft, dateRight);
            // return `${between} seconds`;
            return DifferenceInMinutes(dateLeft, dateRight);
        },

        addMinutes(date, amount) {
            return AddMinutes(date, amount);
        },

        getTotal(start, end) {
            return DifferenceInCalendarDays(end, start);
        },

        AddWeeks(date, total) {
            return AddDays(date, total);
        },

        subDays(data, total) {
            return SubDays(data, total);
        },

        getDaysInMonth(date) {
            return GetDaysInMonth(date);
        },

        startOfMonth(date) {
            return StartOfMonth(date);
        },
    },
};
